/* src/app/features/contratacao/questionario-fgenergia/questionario-fgenergia-pesquisa/questionario-fgenergia-pesquisa.component.scss */
.blur {
  filter: blur(1px);
}
/*# sourceMappingURL=questionario-fgenergia-pesquisa.component.css.map */
